import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail } from "lucide-react";
import usePageTitle from "@/lib/usePageTitle";

const TownshipBoard = () => {
  usePageTitle("Township Board");
  const [officials, setOfficials] = useState([]);

  useEffect(() => {
    api.get("/officials").then((res) => setOfficials(res.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="board-page" className="container-le section-pad">
      <div className="max-w-2xl mb-12">
        <div className="text-xs uppercase tracking-[0.25em] text-secondary mb-3">Local Government</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight">Township Board</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Your elected and appointed Lake Eunice Township officers. Reach any member directly by phone — board members are happy to hear from residents.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {officials.map((o) => (
          <Card key={o.id} className="border-border hover:shadow-md transition-shadow" data-testid={`official-${o.id}`}>
            <CardContent className="p-7">
              <div className="w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center font-heading text-xl mb-5">
                {o.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-accent">{o.title}</div>
              <div className="font-heading text-xl font-semibold mt-1 mb-4">{o.name}</div>
              {o.phone && (
                <a href={`tel:${o.phone}`} className="flex items-center gap-2 text-sm text-foreground/80 hover:text-primary">
                  <Phone size={14} /> {o.phone}
                </a>
              )}
              {o.email && (
                <a href={`mailto:${o.email}`} className="flex items-center gap-2 text-sm text-foreground/80 hover:text-primary mt-2">
                  <Mail size={14} /> {o.email}
                </a>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TownshipBoard;
